import type { ReactElement } from 'react';

import type { SlabTabOption } from './SlabTabContext';
import { SlabTabList } from './SlabTabList';
import { SlabTabProvider } from './SlabTabProvider';
import { SlabTabView } from './SlabTabView';
import { useTabView } from './useTabView';

interface SlabTabBarProps<T extends string> {
  tabs: SlabTabOption<T>[];
  hideIfOnlyOneTab?: boolean;
}

export const SlabTabBar = <T extends string>({
  tabs,
  hideIfOnlyOneTab = false,
}: SlabTabBarProps<T>): ReactElement | null => {
  const { TabViewRef, changeTab } = useTabView();

  if (!tabs.length) return null;

  const [{ label: initialTab }] = tabs;

  return (
    <SlabTabProvider initialTab={initialTab} ref={TabViewRef}>
      <SlabTabList onChangeTab={changeTab} hideIfOnlyOneTab={hideIfOnlyOneTab} tabs={tabs} />
      <SlabTabView tabs={tabs} />
    </SlabTabProvider>
  );
};
